// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"8":"packages","345":"portfolio","353":"contact","543":"gallery","594":"about","609":"faq"}[chunkId] + "." + {"8":"7fa4bcdc","345":"445eb7af","353":"b8f3118a","543":"44e11af2","594":"ca340fb7","609":"24ac01bc"}[chunkId] + ".js";
};